import { observable, action, computed, toJS, autorun } from 'mobx'
import { fetchData } from '../helpers/apiHelpers.js'
import setup from '../setup/setup'
import appConfigObj from '../assets/data/appConfig'

class AppStore {

  @observable 
  appConfig = {}

  fetchAppConfig = autorun((cb) => {
    if (!setup.offline){
      fetchData('appConfig.json', (res) => {
        if (res.success){
          this.appConfig = res.data;
        } else {
          alert(res.err)
        }
      })
    } else {
      this.appConfig = { ...appConfigObj };
    }
  })

  @action
  testAction = () => {

  }

  @computed 
  get getAppConfig(){
    return toJS(this.appConfig)
  }
}

const store = new AppStore();

export default store